import axios, { AxiosResponse } from 'axios';

import { API } from '../../utils/axios';
import { APIResponseStatus } from '../types';
import { env } from '../../env';

interface CreateSessionResponse extends APIResponseStatus {
  resource: {
    accessToken: string;
    expiresAt: number;
    userrole?: string[];
  };
}
interface CreateWSSessionResponse extends APIResponseStatus {
  resource: {
    wsToken: string;
    expiresAt: number;
  };
}

interface ResolveCognitoUsernameResponse extends APIResponseStatus {
  resource: {
    cognitoUsername: string;
  };
}

export interface UpdateMFAPreferenceType {
  username: string;
  mfaType: 'email' | 'sms';
}

class AuthService {
  static createSession(params: { accessToken: string }) {
    return API.post<any, AxiosResponse<CreateSessionResponse>>('v1/auth/sessions', {
      resource: { ...params, userType: 'Patient' },
    });
  }

  static createWSSession(params: { deviceId: string }) {
    return API.post<any, AxiosResponse<CreateWSSessionResponse>>('v1/auth/sessions/ws', {
      resource: { ...params },
    });
  }

  static resolveCognitoUsername(params: { email: string }) {
    return axios.post<any, AxiosResponse<ResolveCognitoUsernameResponse>>(
      `${env.REACT_APP_API_BASE_URL}/v1/auth/resolve-cognito-username`,
      {
        resource: { ...params },
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': env.REACT_APP_API_KEY,
        },
      },
    );
  }

  static async updateMfaPreferenceService(params: UpdateMFAPreferenceType) {
    const res = await API.post<any, AxiosResponse<APIResponseStatus>>(`/v1/auth/mfa/preference`, {
      username: params.username,
      mfaType: params.mfaType,
    });
    return res.data;
  }

  static generateMagicLink(params: { email: string }) {
    return API.post<any, AxiosResponse<APIResponseStatus>>('v1/auth/magic-link/send', {
      resource: { ...params },
    });
  }

  static verifyMagicLink(params: { code: string }) {
    return API.post<any, AxiosResponse<APIResponseStatus>>(
      'v1/auth/magic-link/verify?code=' + params.code,
    );
  }
}

export default AuthService;
